import qs from 'query-string';
import appConfig from 'config/config';
import useService from './axios-config';
import { PNQ, SESSION_STORAGE } from '../constants';
import { getFromSessionStorage } from 'common/utils/app.utils';

const { _get, isApiSuccess } = useService(appConfig.apiBaseUrl);

const pnq_token = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN);

const getNonStandardCpeAsync = (productType, token) => {
  const config = {
    headers: {
      Authorization: token || pnq_token
    }
  };

  const queryParams = {
    configFields: 'COMMERCIAL_ATTRIBUTE',
    productType
  };

  return _get(`${PNQ.GET_NON_STANDARD_CPE}?${qs.stringify(queryParams)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export { getNonStandardCpeAsync };
